import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html'
})
export class PaginationComponent implements OnChanges {
  @Input() currentPage: number = 1;
  @Input() totalItems: number = 0;
  @Input() itemsPerPage: number = 10;
  @Input() maxVisiblePages: number = 5;
  @Input() size: 'sm' | 'md' = 'md';
  
  @Output() pageChange = new EventEmitter<number>();
  
  totalPages: number = 0;
  pages: number[] = [];
  startPage: number = 1;
  endPage: number = 1;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['totalItems'] || changes['itemsPerPage'] || changes['currentPage']) {
      this.calculatePages();
    }
  }

  calculatePages(): void {
    this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
    
    if (this.totalPages <= this.maxVisiblePages) {
      this.startPage = 1;
      this.endPage = this.totalPages;
    } else {
      const maxPagesBeforeCurrentPage = Math.floor(this.maxVisiblePages / 2);
      const maxPagesAfterCurrentPage = Math.ceil(this.maxVisiblePages / 2) - 1;
      
      if (this.currentPage <= maxPagesBeforeCurrentPage) {
        this.startPage = 1;
        this.endPage = this.maxVisiblePages;
      } else if (this.currentPage + maxPagesAfterCurrentPage >= this.totalPages) {
        this.startPage = this.totalPages - this.maxVisiblePages + 1;
        this.endPage = this.totalPages;
      } else {
        this.startPage = this.currentPage - maxPagesBeforeCurrentPage;
        this.endPage = this.currentPage + maxPagesAfterCurrentPage;
      }
    }
    
    // Create array of pages
    this.pages = Array.from(
      { length: this.endPage - this.startPage + 1 },
      (_, i) => this.startPage + i
    );
  }

  onPageClick(page: number): void {
    if (page !== this.currentPage && page >= 1 && page <= this.totalPages) {
      this.pageChange.emit(page);
    }
  }

  onPreviousClick(): void {
    if (this.currentPage > 1) {
      this.pageChange.emit(this.currentPage - 1);
    }
  }

  onNextClick(): void {
    if (this.currentPage < this.totalPages) {
      this.pageChange.emit(this.currentPage + 1);
    }
  }

  isFirstPage(): boolean {
    return this.currentPage === 1;
  }

  isLastPage(): boolean {
    return this.currentPage === this.totalPages;
  }
}